import {Text} from 'src/v2/components/common/Text';
import {LinkTitleWrapper} from 'src/v2/components/screen/link/LinkTitleWrapper';

import {message, useIntl} from '@sail/intl';

const messages = {
  title: message({
    id: 'crypto.payins.v2.heading.setup_title',

    description:
      'Header for the screen when saving a payment method for future usage',

    defaultMessage: 'Add payment method',
  }),
};

export const SetupTitle = () => {
  const intl = useIntl();

  return (
    <LinkTitleWrapper>
      <Text type="headline">{intl.formatMessage(messages.title)}</Text>
    </LinkTitleWrapper>
  );
};
